import store from '../../../store'

export default [{
    path: '/app/account',
    redirect: {
        name: 'dashboard'
    },
    component: () => import('../../../components/dashboard/AccountComponent.vue'),
    children: [{
            path: '/app/account/profile',
            name: 'account.profile',
            redirect: {
                name: (store.state.user.type === 'client') ? 'account.profile.personal-information' : 'account.profile.back-office'
            },
            component: () => import('../../../components/dashboard/ProfileComponent.vue'),
            children: [{
                    path: '/app/account/profile',
                    name: 'account.profile.back-office',
                    component: () => import('../../../components/dashboard/back-office/ProfileComponent.vue'),
                    meta: {
                        allowedUsers: ['back-office']
                    }
                },
                {
                    path: '/app/account/profile/personal-information',
                    name: 'account.profile.personal-information',
                    component: () => import('../../../components/dashboard/client/profile/PersonalInformationComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/account/company/profile-information',
                    name: 'account.company-profile',
                    component: () => import('../../../components/dashboard/client/profile/ProfileInformationComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/account/company/executive-information',
                    name: 'account.company-profile.executive-information',
                    component: () => import('../../../components/dashboard/client/profile/ExecutiveInformationComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/account/company/financial-information',
                    name: 'account.company-profile.financial-information',
                    component: () => import('../../../components/dashboard/client/profile/FinancialInformationComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/account/company/bank-account-information',
                    name: 'account.company-profile.bank-account-information',
                    component: () => import('../../../components/dashboard/client/profile/BankAccountInformationComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                // {
                //     path: '/app/account/profile/risk-profile',
                //     name: 'account.company-profile.risk-profile',
                //     component: () => import('../../../components/dashboard/client/profile/RiskProfileComponent.vue'),
                //     meta: {
                //         allowedUsers: ['client']
                //     }
                // },
                {
                    path: '/app/account/profile/investment-management-agreement',
                    name: 'account.company-profile.investment-management-agreement',
                    component: () => import('../../../components/dashboard/client/profile/InvestmentManagementAgreementComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                }
            ]
        },
        {
            path: '/app/account/settings',
            name: 'account.settings',
            redirect: {
                // name: 'account.settings.alerts'
                name: 'account.settings.change-password',
            },
            component: () => import('../../../components/dashboard/SettingsComponent.vue'),
            children: [
                // {
                //     path: '/app/account/settings/alerts',
                //     name: 'account.settings.alerts',
                //     component: () => import('../../../components/dashboard/client/settings/AlertsComponent.vue'),
                //     meta: {
                //         allowedUsers: ['client']
                //     }
                // },
                {
                    path: '/app/account/settings/change-password',
                    name: 'account.settings.change-password',
                    component: () => import('../../../components/dashboard/client/settings/ChangePasswordComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                },
                {
                    path: '/app/account/settings/change-company-accout',
                    name: 'account.settings.change-compaany-account',
                    component: () => import('../../../components/dashboard/client/settings/SelectCompanyComponent.vue'),
                    meta: {
                        allowedUsers: ['client']
                    }
                }
            ]
        },

    ]
}]
